import { API_BASE, messageFromErrorBody } from './authApi';
import { authHeaders } from './authStorage';

const jsonHeaders = () => ({
  'Content-Type': 'application/json',
  Accept: 'application/json',
  ...authHeaders(),
});

/** Same shape as member decisions API for UI parity */
function mapShareholderDecisionFromApi(d) {
  return {
    id: d.id,
    title: d.title ?? '',
    description: d.description ?? '',
    branch: d.branch ?? '',
    creator: d.creator ?? '',
    date: d.date ?? '',
    deadline: d.deadline ?? '',
    status: d.status ?? 'pending',
    priority: d.priority ?? 'medium',
    attachments: Array.isArray(d.attachments) ? d.attachments : [],
    votes: Array.isArray(d.votes) ? d.votes.map((v) => ({
      member: v.member ?? '',
      vote: v.vote ?? 'abstain',
      note: v.note ?? '',
    })) : [],
    totalMembers: d.totalMembers ?? 0,
    myVote: d.myVote ?? null,
    myNote: d.myNote ?? '',
    myVotedAt: d.myVotedAt ?? null,
  };
}

export async function fetchShareholderDecisions() {
  const res = await fetch(`${API_BASE}/api/shareholder/decisions`, {
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحميل القرارات'));
  const list = Array.isArray(data) ? data : [];
  return list.map(mapShareholderDecisionFromApi);
}

export async function fetchShareholderDecisionById(id) {
  const res = await fetch(`${API_BASE}/api/shareholder/decisions/${id}`, {
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحميل القرار'));
  return mapShareholderDecisionFromApi(data);
}

export async function submitShareholderDecisionVote(id, payload) {
  const res = await fetch(`${API_BASE}/api/shareholder/decisions/${id}/vote`, {
    method: 'POST',
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر إرسال التصويت'));
  return mapShareholderDecisionFromApi(data);
}
